module.exports = __webpack_public_path__ + "static/media/Apollo.f68a24be.svg";